/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';

import { getState } from './baseSelectors';

export const getUser = createSelector(getState, ({ user }) => ({
  ...user,
}));
